
const str1 = 'Оба поля должны быть заполнены';
const str2 = 'Введите логин';
const str3 = 'Введите пароль';

export function validateForm(login, password) {
    if (!login && !password) {
        return {isValid: false, message: str1};
    }
    if (!login) {
        return {isValid: false, message: str2};
    }
    if (!password) {
        return {isValid: false, message: str3};
    }
    return {isValid: true, message: null}
}